module.exports = __webpack_public_path__ + "static/media/login-bg.7842fc66.jpg";